"use client";

import { useEffect } from "react";

import { usePathname } from "next/navigation";

import { countriesType } from "lib/types";

export default function LocaleScript() {
  const pathname = usePathname();

  useEffect(() => {
    let locale = "sv"; // default
    const defaultLocale = process.env.DEFAULT_LOCALE as countriesType;

    if (pathname.startsWith("/en")) locale = "en";
    else locale = defaultLocale;

    document.documentElement.setAttribute("lang", locale);
  }, [pathname]);

  return null; // This component doesn't render anything
}
